import { getAvailableDatesSet, formatYMD } from '@/utils/excursionAvailability';
import { scheduleMatchesLanguage } from '@/utils/excursionLanguageFilter';

/**
 * Human-readable next available date after the selected date, respecting optional language filter.
 * @param {Date|string} selectedDate
 * @param {string|null} languageCode
 * @param {Array} schedules
 * @param {{ isDateBookable?: (ymd: string) => boolean }} [options]
 */
export const getNextAvailableExcursionDateLabel = (
  selectedDate,
  languageCode,
  schedules,
  options = {},
) => {
  if (!selectedDate || !Array.isArray(schedules) || schedules.length === 0) return null;

  const dateObj = selectedDate instanceof Date ? new Date(selectedDate) : new Date(selectedDate);
  if (Number.isNaN(dateObj.getTime())) return null;
  dateObj.setHours(0, 0, 0, 0);
  const selectedYmd = formatYMD(dateObj);

  const schedulesForSuggestion = schedules.filter((s) => scheduleMatchesLanguage(s, languageCode));
  if (!schedulesForSuggestion.length) return null;

  const availableSet = getAvailableDatesSet(schedulesForSuggestion, { fromDate: dateObj, monthsAhead: 12 });
  const isDateBookable = typeof options.isDateBookable === 'function'
    ? options.isDateBookable
    : () => true;

  const nextYmd = Array.from(availableSet)
    .filter((ymd) => ymd > selectedYmd && isDateBookable(ymd))
    .sort()[0];
  if (!nextYmd) return null;

  const [y, m, d] = nextYmd.split('-').map(Number);
  const nextDate = new Date(y, m - 1, d);
  return nextDate.toLocaleDateString(undefined, {
    weekday: 'long',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
